<template>
  <chart-container :titleChart="titleChart" @onCSVDownload="downloadCsv(titleChart)" @zoomEnabled="zoomGraph(true)" @zoomDisabled="zoomGraph(false)" :downloadId="downloadId" :specificSiteId="specificSiteId" :zoomGraphValue="zoomGraphValue" :downloadShow="dataSource.data && Object.keys(dataSource.data).length > 0">
    <span slot="header" class="float-right enrol-tabs">
      <b-tabs>
        <b-tab v-for="(tabName, index) in tabOverallMissing" :key="index" :title="tabName" @click="tabChange(index)" />
      </b-tabs>
    </span>
    <fusioncharts style="width: 100%;" :type="type" :width="width" :height="height" :dataFormat="dataFormat" :dataSource="dataSource" dataEmptyMessage="No Data In" v-if="dataSource.data && Object.keys(dataSource.data).length > 0" slot="body" />
    <div v-else class="align-center p-60" slot="body">
      <div class="card-text-title no-data" v-if="dataLoaded">No Data In</div>
    </div>
  </chart-container>
</template>

<script>
import Vue from "vue";
import VueFusionCharts from "vue-fusioncharts";
import FusionCharts from "fusioncharts";
import moment from "moment";
import ChartContainer from "./chart-container.vue";
import * as srv from "../../services/visualization/data-management";

Vue.use(VueFusionCharts, FusionCharts);

export default {
  components: {
    ChartContainer
  },
  props: {
    containerClass: {
      type: String,
      default: "thread-chart",
      zoomGraphValueChild: ""
    },
    zoomGraphValue: { type: String, default: "" },
    specificSiteId: [Object, Array],
    titleChart: { type: String, default: "" },
    subtitleChart: { type: String, default: "" },
    sitesSelected: [Array, String],
    countrySelected: [Array, String],
    rawSeries: { type: Object, default: () => {} },
    countryList: { type: Array, default: () => [] },
    allSiteList: { type: Array, default: () => [] },
    dataLoaded: { type: Boolean, default: false }
  },
  data() {
    return {
      type: "line",
      downloadId: "overall-missing-data",
      tab: 0,
      xAxisName: "Days",
      yAxisName: "Number of Missing Data Points",
      tooltip: "Missing Data Points",
      dataFormat: "json",
      renderAt: "chart-container",
      tabOverallMissing: ["Total", "Percentage"],
      width: "100%",
      height: "250",
      dataSource: {
        chart: {
          xAxisNameFont: "RobotoRegular",
          xAxisNameFontSize: "9px",
          labelFontSize: "10px",
          labelFont: "RobotoRegular",
          labelFontColor: "#a3a3a3",
          yAxisNameFont: "RobotoRegular",
          yAxisNameFontSize: "9px",
          yAxisValueFont: "RobotoRegular",
          yAxisValueFontSize: "10px",
          yAxisValueFontColor: "#a3a3a3",
          showLegend: false,
          lineThickness: "2",
          compactdatamode: "1",
          dataSeparator: "|",
          theme: "fusion",
          xAxisName: "Days",
          yAxisName: "Number of Missing Data Points",
          xAxisNameFontColor: "#959fa4",
          yAxisNameFontColor: "#959fa4",
          divLineAlpha: "0",
          divLineDashed: "0",
          anchorBgColor: srv.primaryColorFnc(),
          anchorBgHoverColor: srv.primaryColorFnc(),
          anchorBorderColor: srv.primaryColorFnc(),
          paletteColors: srv.primaryColorFnc() + ",#a6cee3,#7891d1,#56b3b9,#cab2d6,#7f69d4,#fb9a99,#fdbf6f,#b5cdd8",
          tooltipBorderAlpha: "0",
          toolTipBgAlpha: "0",
          plotToolText: `$dataValue ${this.tooltip}`,
          canvasPadding: 50,
          numbersuffix: "",
          canvasTopPadding: "10",
          showXAxisLine: true,
          showYAxisLine: true,
          xaxislinethickness: "1",
          yaxislinethickness: "1",
          xAxisLineColor: "#b0bac9",
          yAxisLineColor: "#b0bac9",
          drawCrossLine: false,
          chartBottomMargin: "0",
          xAxisNamePadding: "5",
          decimals: 3
        },
        data: []
      },
      zoomGraphValueChild: "",
      todayDate: "",
      tDateShow: true,
      csvData: [],
      getSiteID: srv.getSiteID
    };
  },

  watch: {
    zoomGraphValue: function(newVal) {
      this.zoomGraphValueChild = newVal;
      if (newVal == "") {
        this.height = "250";
      }
    },
    rawSeries: function(newValue) {
      const data = srv.getDataOverallMissingData(newValue, this.countrySelected, this.sitesSelected, this.tab);
      const csvData = srv.getDataOverallMissingData(newValue, this.countrySelected, this.sitesSelected, this.tab, "csvData");

      this.csvData = csvData;
      this.dataSource.data = data;
      this.dataSource.chart.anchorBgColor = srv.primaryColorFnc();
      this.dataSource.chart.anchorBgHoverColor = srv.primaryColorFnc();
      this.dataSource.chart.anchorBorderColor = srv.primaryColorFnc();
      this.dataSource.chart.paletteColors = srv.primaryColorFnc() + ",#a6cee3,#7891d1,#56b3b9,#cab2d6,#7f69d4,#fb9a99,#fdbf6f,#b5cdd8";
      this.dataSource.chart.plotToolText = this.generateTooltips("", this.tooltip);
    },
    countrySelected: function(newValue) {
      this.countrySelected = newValue;
      const data = srv.getDataOverallMissingData(this.rawSeries, this.countrySelected, this.sitesSelected, this.tab);
      const csvData = srv.getDataOverallMissingData(this.rawSeries, this.countrySelected, this.sitesSelected, this.tab, "csvData");

      this.csvData = csvData;
      this.dataSource.data = data;
      this.dataSource.chart.plotToolText = this.generateTooltips("", this.tooltip);
    },
    sitesSelected: function(newValue) {
      this.sitesSelected = newValue;
      const data = srv.getDataOverallMissingData(this.rawSeries, this.countrySelected, this.sitesSelected, this.tab);
      const csvData = srv.getDataOverallMissingData(this.rawSeries, this.countrySelected, this.sitesSelected, this.tab, "csvData");

      this.csvData = csvData;
      this.dataSource.data = data;
      this.dataSource.chart.plotToolText = this.generateTooltips("", this.tooltip);
    }
  },
  methods: {
    tabChange(newValue) {
      this.tab = newValue;
      const isPercenTab = newValue === 1;
      const percen = isPercenTab ? "%" : "";

      const countrySelected = this.countrySelected === "all" ? this.countryList : this.countrySelected;
      const sitesSelected = this.sitesSelected[0] === "all" ? this.allSiteList : this.sitesSelected;
      const data = srv.getDataOverallMissingData(this.rawSeries, countrySelected, sitesSelected, newValue);
      const csvData = srv.getDataOverallMissingData(this.rawSeries, countrySelected, sitesSelected, newValue, "csvData");

      this.csvData = csvData;
      this.dataSource.data = data;
      this.dataSource.chart.numbersuffix = percen;
      this.dataSource.chart.yaxismaxvalue = isPercenTab ? "100" : "";
      this.dataSource.chart.plotToolText = this.generateTooltips("", this.tooltip);
    },
    zoomGraph(status) {
      if (status) {
        this.zoomGraphValueChild = true;
        this.height = "400";
        this.$emit("zoomEnabled");
      } else {
        this.zoomGraphValueChild = false;
        this.height = "250";
        this.$emit("zoomDisabled");
      }
    },
    generateTooltips(percent, tooltipTitle) {
      const tooltips = `
        <span class="overall-collection-metric-tooltip completed" style='color:${srv.primaryColorFnc}'>
            $dataValue${percent + " " + tooltipTitle}
        </span>
      `;

      return tooltips;
    },
    downloadCsv(titleChart) {
      this.todayDate = moment()
        .format("DD MMM YYYY hh:mm:ss")
        .toUpperCase();
      this.tDateShow = false;

      setTimeout(() => {
        const header = ["Days", "Total Missing Data Points"];
        this.tDateShow = true;
        header[1] = this.tab < 1 ? "Total Missing Data Points" : "Percentage Missing Data Points";

        const newArr = [];
        this.csvData.map(row => {
          const value = this.tab < 1 ? row.value : row.value + "%";
          newArr.push([row.label, value]);
        });

        srv.downloadCSV(titleChart, header, newArr, this.specificSiteId);
      }, 1);
    }
  }
};
</script>
<style lang="scss" scoped>
#app,
.container-line-chart {
  width: 100%;
}
</style>
